module.exports = __webpack_public_path__ + "static/media/phone.b98c7de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PhoneFrame/phone.png
// module id = 124
// module chunks = 0